<script>
import ClientFactory from "@/api/ClientFactory";
const api = ClientFactory.get("license");
import { mapActions } from "vuex";

export default {
    data: () => ({
        license_key: "",
        info: null,
        error: null,
        success: false
    }),

    methods: {
        ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
        async activeLicense() {
            this.loading(this.$vs);
            // Step 1: submit license key
            const {expired, sub, iss, issuedAt, error} = await api.active(this.license_key.trim());
            if(error) {
                this.success = false;
                this.error = error;
                this.info = null;
                this.notify({
                    error: true,
                    text: error,
                })
            } else {
                // Step 2: display license information.
                this.error = null;
                this.info = { expired, sub, iss, issuedAt};
                this.success = true;
            }
            
            this.closeLoading();
        },
        async getLicenseInfo() {
            //this.loading(this.$vs);
            const {expired, sub, iss, issuedAt, error} = await api.getInfo();
            if(error) {
                this.error = error;
                this.info = null;
            } else {
                this.success = true;
                this.error = null;
                this.info = { expired, sub, iss, issuedAt}
            }

            this.closeLoading();
            
        }
    },
    created() {
        this.closeLoading();
    },
    mounted() {
        this.getLicenseInfo();
    },
    destroyed() {
        this.closeLoading();
    }
    
}
</script>

<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
        <div class="clearfix">
            <h3 class="left">Thông tin giấy phép phần mềm</h3>
            <p v-if="error" class="text-muted center">{{error}}</p>
            <span v-if="info" class="left">{{info.sub}}</span>
            <span v-if="info" class="left"> Ngày đăng ký: {{info.issuedAt}}</span>
            <span v-if="info" class="left"> Hết hạn: {{info.expired}}</span>
            <hr>
            <CInput
                class="mb-3"
                placeholder="Điền license key tại đây"
                v-model="license_key"
                >
                <template #append>
                    <CButton color="info" @click="activeLicense">Kích hoạt giấy phép</CButton>
                </template>
            </CInput>
            <CButton v-if="success" color="primary" class="px-4" to="/">Quay lại trang chủ</CButton>
        </div>
        
      
    </CRow>
    
  </CContainer>
</template>